<template>
  <perspective-table-editor tablename="csv" />
</template>
<script setup>
  import PerspectiveTableEditor from '@/components/PerspectiveTableEditor.vue';
</script>
